import { render, staticRenderFns } from "./delivery-code.vue?vue&type=template&id=2e25b343&scoped=true"
import script from "./delivery-code.vue?vue&type=script&lang=js"
export * from "./delivery-code.vue?vue&type=script&lang=js"
import style0 from "./delivery-code.vue?vue&type=style&index=0&id=2e25b343&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e25b343",
  null
  
)

export default component.exports